import { Injectable } from "@angular/core";
import { AppService } from "../../core/service/Base.Service";

@Injectable()
export class CustomService extends AppService<any> {
  constructor() {
    super("");
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ixs-report/custom-service.ts